export default "__VITE_ASSET__e3009bb5__"